const routes = [
    {
        path: 'nova-solicitacao',
        name: 'NovaSolicitacaoBeneficio',
        component: () => import('./FormNovaSolicitacao.vue'),

        props: (route) => ({
            titulo: route.params.titulo,
            editando: route.params.editando === true || route.params.editando === 'true',
        }),
        meta: {
            rules: [''],
        },
    },
    {
        path: 'nova-solicitacao/editar/:id',
        name: 'EditarSolicitacaoBeneficio',
        component: () => import('./FormNovaSolicitacao.vue'),
        props: (route) => ({
            titulo: route.params.titulo,
            editando: true,
            id: route.params.id,
        }),
        meta: { rules: [''] },
    },
];

export default routes;
